'use client'
import React, { useState, useEffect, useRef } from 'react'
import { useSession } from 'next-auth/react'
import Image from 'next/image'
import Link from 'next/link'
import { AiOutlineLayout } from "react-icons/ai"
import { BiSolidBed, BiSolidBath } from "react-icons/bi"
import CurrencySymbol from '@components/CurrencySymbol'
import LinkComponent from '@components/LinkComponent'

import tailwindConfig from '@tailwind.config'


const MobileMapProjectCard = ({ project, imageWidth = 150, imageHeight = 80, includeInactive = false, newLimit, isLast, district = undefined, newDevelopment = false, dictionary, lang }) => {
    const style = {
        // color: tailwindConfig.theme.extend.colors.secondary,
        // height: 65,
        // overflow: 'hidden',
        // z: 10
    };

    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    // const [isLiked, setIsLiked] = useState(project.isLiked)
    const { data: session } = useSession()

    const cardRef = useRef();



    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    return (
        <div ref={cardRef} className={`relative sm:w-[${imageWidth}px] w-full p-2 `}>
            <LinkComponent
                href={`/${newDevelopment ? 'new-developments' : 'projects'}/` + project.slug}
                className='border-forth border-[1px] border-solid'
            >
                <div className='flex flex-col bg-light rounded-md'>
                    <div className='flex flex-row'>
                        <div className='relative w-[170px]'>
                            <Image
                                placeholder="blur"
                                blurDataURL={project.blur}
                                className='w-[170px] rounded-md'
                                src={project.cover || '/images/placeholder.jpg'}
                                width={imageWidth}
                                height={imageHeight}
                                alt={project.slug}
                            />
                            {project.isPromotion ? (
                                <div className='absolute top-1 bg-third text-light px-1 text-sm rounded-r-md z-10 font-semibold'>{project.promotionTitle}</div>
                            ) : null
                            }
                        </div>
                        <div className='w-full p-1' >
                            <div width={imageWidth} className='text-sm font-semibold text-maincolor relative flex flex-col justify-between overflow-hidden h-[40px]' title={project.name}>
                                <h2>
                                    {project.name}
                                </h2>

                                <div className='sm:absolute z-40 right-0 left-0 bottom-0 sm:h-[30px] h-0 bg-gradient-to-b from-transparent to-light'></div>

                            </div>
                        </div>
                    </div>
                    {project.publicTransport ? (
                        <div className='flex flex-row flex-wrap my-1'>
                            {project.publicTransport.map((transport, index) => (
                                <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-[1px] mb-[1px]`}>{transport.type.toUpperCase()} {transport.transportName?.[lang] ? transport.transportName[lang] : transport.stationName}</div>
                            ))}
                        </div>
                    ) : null}

                </div>
            </LinkComponent >
        </div>
    )
}

export default MobileMapProjectCard